import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import '../VehicleDetails.scss'
import { formatNumber, removeAccents } from 'utils/utils'
import { config } from 'config/config'

import VehicleDetails from '../index'

const hasAveragePrice = averagePrice =>
  averagePrice && (averagePrice.MediumPrice || averagePrice.FipePrice)

const getMakeValue = make => {
  const makeLowerCase = make.toLowerCase()
  const makeSanitized = makeLowerCase.replace(/ /g, '-').replace(/\./g, '')
  return removeAccents(makeSanitized)
}

const getModelValue = model => {
  const makeLowerCase = model.toLowerCase()
  const makeSanitized = makeLowerCase
    .replace(/ /g, '-')
    .replace(/\.|\//g, '')
    .replace(/-&-/g, '-')
  return removeAccents(makeSanitized)
}

const getVersionvalue = version => {
  if (!version) return ''
  const versionLowerCase = version.Value.toLowerCase()
  const versionSanitized = versionLowerCase
    .replace(/ /g, '-')
    .replace(/\./g, '')
  return removeAccents(versionSanitized)
}

const getUFSeller = uf => uf.toLowerCase()

const getVehicleType = vehicleType => {
  const VEHICLE_TYPES = {
    car: 'carros',
    bike: 'motos',
  }
  return VEHICLE_TYPES[vehicleType]
}

const getYearModel = year => formatNumber(year).replace('.', '')

const getUrlLinkVehicleDetailFipe = ({ vehicleType, adData, seller }) => {
  const make = `${config.urlTableFipe}${getVehicleType(
    vehicleType
  )}/${getMakeValue(adData.Specification.Make.Value)}`

  const model = `${getModelValue(
    adData.Specification.Model.Value
  )}/${getYearModel(adData.Specification.YearModel)}`

  const uf = seller.UF
    ? `/${getVersionvalue(adData.Specification.Version)}?uf=${getUFSeller(
        seller.UF
      )}`
    : ''

  return `${make}/${model}${uf}`
}

const getMessageLink = (make, model) => {
  return (<Fragment>Consulte aqui <strong>{make} {model} na tabela FIPE Webmotors</strong> do seu estado.</Fragment>)
}

const VehicleDetailsFipe = ({
  className,
  id,
  title,
  averagePrice,
  adData,
  vehicleType,
  seller,
}) => {
  if (hasAveragePrice(averagePrice)) {
    return (
      <VehicleDetails className={className} id={id} title={title}>
        <div className="VehicleDetailsFipe">
          <div className="VehicleDetails__container__header">
            <h2 className="VehicleDetails__container__header__title">
              Compare os preços
            </h2>
          </div>
          <div className="VehicleDetailsFipe__container__info">
            <div className="VehicleDetailsFipe__price VehicleDetailsFipe__price--announced">
              <span className="VehicleDetailsFipe__price__title">
                Valor anunciado
              </span>
              <strong className="VehicleDetailsFipe__price__value">
                R${' '}
                {adData && adData.Prices && adData.Prices.Price
                  ? formatNumber(parseFloat(adData.Prices.Price), 0)
                  : '0'}
              </strong>
            </div>
            <div className="VehicleDetailsFipe__price VehicleDetailsFipe__price--webmotors">
              <span className="VehicleDetailsFipe__price__title">
                Webmotors
              </span>
              <strong className="VehicleDetailsFipe__price__value">
                R${' '}
                {averagePrice && averagePrice.MediumPrice
                  ? formatNumber(parseFloat(averagePrice.MediumPrice), 0)
                  : '0'}
              </strong>
              <p className="VehicleDetailsFipe__price__value-average">
                Valor médio de carros iguais a este
                <br /> anunciado na Webmotors
              </p>
            </div>
            <div className="VehicleDetailsFipe__price VehicleDetailsFipe__price--fipe">
              <span className="VehicleDetailsFipe__price__title VehicleDetailsFipe__price__title--fipe">
                fipe
              </span>
              <strong className="VehicleDetailsFipe__price__value">
                R${' '}
                {averagePrice && averagePrice.FipePrice
                  ? formatNumber(parseFloat(averagePrice.FipePrice), 0)
                  : '0'}
              </strong>
              <p className="VehicleDetailsFipe__price__value-average">
                Valor{' '}
                {vehicleType && vehicleType === 'car'
                  ? 'deste carro'
                  : 'desta moto'}
                <br /> na Tabela Fipe
              </p>
            </div>
          </div>
          <a
            rel="noreferrer"
            className="check-here-fipe"
            target="_blank"
            href={getUrlLinkVehicleDetailFipe({ vehicleType, adData, seller })}
          >
            {getMessageLink(
              adData.Specification.Make.Value,
              adData.Specification.Model.Value
            )}
          </a>
        </div>
      </VehicleDetails>
    )
  }
  return null
}

VehicleDetailsFipe.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string.isRequired,
  title: PropTypes.string,
  vehicleType: PropTypes.string.isRequired,
  averagePrice: PropTypes.shape({
    MediumPrice: PropTypes.number.isRequired,
    FipePrice: PropTypes.number.isRequired,
  }),
  seller: PropTypes.shape({
    UF: PropTypes.string,
  }).isRequired,
  adData: PropTypes.shape({
    Specification: PropTypes.shape({
      Make: PropTypes.shape({ Value: PropTypes.string }),
      Model: PropTypes.shape({ Value: PropTypes.string }),
    }).isRequired,
    Prices: PropTypes.shape({
      Price: PropTypes.string.isRequired,
    }),
  }).isRequired,
}

VehicleDetailsFipe.defaultProps = {
  id: '',
  title: '',
  averagePrice: {
    MediumPrice: 0,
    FipePrice: 0,
  },
}

export default VehicleDetailsFipe
